<template>
    <v-row dense>
        <v-col :cols="widthNumberField" :class="classNumber">
            <!-- <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                slim
            > 
            :error-messages="errors"
            -->
                <v-select 
                    :items="getPeriodNumbers()" 
                    v-model="selectedNumber"
                    :disabled="periodNumbersDisabled"
                    :outlined="outlined"
                    :hide-details="hideDetails"
                    @click:clear="resetVal('number')"
                    menu-props="offset-y"
                    
                    :alvqa="alvqa + '-dropdown-period-selector-numbers'"
                >
                    <template v-slot:item="{ item }">
                        <div :alvqa="item.alvqa">
                            {{ item.text }}
                        </div>
                    </template>
                    <template v-slot:selection="{ item }">
                        <div :alvqa="item.alvqa">
                            {{ item.text }}
                        </div>
                    </template>
                </v-select>
            <!-- </ValidationProvider> -->
        </v-col>
        <v-col :cols="widthTimeUnitField" :class="classTimeUnit">
            <v-select 
                :items="getPeriodTimeUnits()" 
                v-model="selectedTimeUnit"
                :label="label"
                :outlined="outlined"
                :hide-details="hideDetails"
                @click:clear="resetVal('timeUnit')"
                :clearable="clearable"
                menu-props="offset-y"
                :alvqa="alvqa + '-dropdown-period-selector-time-units'"
            >
                <template v-slot:item="{ item }">
                    <div :alvqa="item.alvqa">
                        {{ $t(item.text) }}
                    </div>
                </template>
                <template v-slot:selection="{ item }">
                    <div :alvqa="item.alvqa">
                        {{ $t(item.text) }}
                    </div>
                </template>
            </v-select>
        </v-col>
        <v-col :cols="widthYearField" :class="classYear">
            <v-select 
                :items="getPeriodYears()" 
                v-model="selectedYear"
                :disabled="periodYearsDisabled"
                :outlined="outlined"
                :hide-details="hideDetails"
                @click:clear="resetVal('year')"
                menu-props="offset-y"
                :alvqa="alvqa + '-dropdown-period-selector-years'"
            >
                <template v-slot:item="{ item }">
                    <div :alvqa="item.alvqa">
                        {{ item.text }}
                    </div>
                </template>
                <template v-slot:selection="{ item }">
                    <div :alvqa="item.alvqa">
                        {{ item.text }}
                    </div>
                </template>
            </v-select>
        </v-col>
    </v-row>    
</template>

<script>
import { DropdownGeneralPeriodTimeUnits, DropdownGeneralPeriodTimeUnitsWithUndefined, DropdownGeneralPeriodTimeUnitsWithoutMonth } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "BasePeriod",
    props: {
        undefinedTimeUnit: {
            type: Boolean,
            default: false
        },
        monthNotAllowed: {
            type: Boolean,
            default: false
        },
        widthNumberField: {
            type: Number | String,
            default: 3
        },
        widthYearField: {
            type: Number | String,
            default: 3
        },
        widthTimeUnitField: {
            type: Number | String,
            default: 3
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        classNumber: {
            type: String,
            default: "pr-1"
        },
        classYear: {
            type: String,
            default: "pl-1"
        },
        justify: {
            type: String,
            default: "start"
        },
        clearable: Boolean,
        classTimeUnit: String,
        outlined: Boolean,
        periodLabel: String,
        context: String
    },
    data() {
        return {
            periodNumbersDisabled: false,
            periodYearsDisabled: false,
            alvqa: "period-selector"
        }
    },
    computed: {
        label() { return this.$t(this.periodLabel) },

        selectedNumber: {
            get() { return this.$store.getters['getSelectedPeriodNumber'+this.context] },
            set(number) { this.$store.commit('setSelectedPeriodNumber'+this.context, number) }
        },
        selectedTimeUnit: {
            get() { return this.$store.getters['getSelectedPeriodTimeUnit'+this.context] },
            set(value) { 
                if(value === 'notDefined') {
                    this.selectedNumber = null
                    this.selectedYear = null
                }

                if(value === 'halfyear' || value === 'year') this.selectedNumber = null
                
                this.$store.commit('setSelectedPeriodTimeUnit'+this.context, value) 
            }
        },
        selectedYear: {
            get() { return this.$store.getters['getSelectedPeriodYear'+this.context] },
            set(year) { this.$store.commit('setSelectedPeriodYear'+this.context, year) }
        } 
    },
    methods: {
        getPeriodNumbers() {
            switch(this.$store.getters["getSelectedPeriodTimeUnit"+this.context]){
                case 'month':
                    let months = []
                    for(let i = 1; i <= 12; i++) {
                        months.push(
                            {text: i, value: i, alvqa: this.alvqa + '-dropdown-period-selector-numbers-' + i}
                        )
                    }
                    this.periodNumbersDisabled = false
                    return months
                case 'quarter':
                    let quarters = []
                    for(let i = 1; i <= 4; i++) {
                        quarters.push(
                            {text: i, value: i, alvqa: this.alvqa + '-dropdown-period-selector-numbers-' + i}
                        )
                    }
                    this.periodNumbersDisabled = false
                    return quarters
                case 'halfyear':
                    this.periodNumbersDisabled = false
                    return [
                            {text: 1, value: 1, alvqa: this.alvqa + '-dropdown-period-selector-numbers-1'},
                            {text: 2, value: 2, alvqa: this.alvqa + '-dropdown-period-selector-numbers-2'},
                    ]
                case 'year':
                    this.periodNumbersDisabled = true
                    return []
                case 'notDefined':
                    this.periodNumbersDisabled = true
                    break
                default:
                    this.periodNumbersDisabled = true
            }
        },
        getPeriodTimeUnits() {
            if(this.undefinedTimeUnit) return DropdownGeneralPeriodTimeUnitsWithUndefined
            else if(this.monthNotAllowed) return DropdownGeneralPeriodTimeUnitsWithoutMonth
            else return DropdownGeneralPeriodTimeUnits
        },
        getPeriodYears() {
            let years = []

            if(
                this.$store.getters["getSelectedPeriodTimeUnit"+this.context] === 'notDefined' || 
                this.$store.getters["getSelectedPeriodTimeUnit"+this.context] === null
            ) this.periodYearsDisabled = true
            else {
                this.periodYearsDisabled = false
                let maxYear = new Date().getFullYear()+1
                for(let i = maxYear; i >= 2008; i--) {
                    years.push(
                        {
                            text: i,
                            value: i, 
                            alvqa: this.alvqa + '-dropdown-period-selector-years-' + i
                        }
                    )
                } 
                return years
            }
        },

        numberValidation() {
            switch(this.selectedTimeUnit) {
                case 'month': case 'quarter': case 'halfyear':
                    return "required"
                default: return ''
            }
        },

    // Validations
        // numberValidation() {
        //     switch(this.selectedTimeUnit) {
        //         case 'month': case 'quarter': case 'halfyear':
        //             return "required"
        //         default: return ''
        //     }
        // },

        async resetVal(val) {
            await this.$nextTick()
            switch(val) {
                case 'number': 
                    this.selectedNumber = null
                    break
                case 'year': 
                    this.selectedYear = null
                    break
                case 'timeUnit':
                    this.selectedNumber = null
                    this.selectedYear = null

                    if(this.undefinedTimeUnit === true) this.selectedTimeUnit = 'notDefined' 
                    else this.selectedTimeUnit = null
                    break
            }
        }
    }
}
</script>